<template>
	<div>

		<v-layout row
		 class="mb-2 mt-0 back-btn">
			<v-flex xs12
			 class="text-xs-center">
				<v-btn outline
				 to="/recordings"
				 color="#331d2c"
				 class="primary--text">
					<v-icon left
					 dark> mdi-undo</v-icon>
					Go back
				</v-btn>
			</v-flex>
		</v-layout>

		<v-layout row
		 class="mb-4"
		 justify-center>
			<v-flex xs12>
				<v-card>
					<v-card-title class='mb-2 text-xs-center'>
						<h1> {{thisUlaTranscription.title}} </h1>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text v-if="thisUlaTranscription.title != thisUlaTranscription.date">
						Made at: {{thisUlaTranscription.date}}
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

		<v-divider v-if="audioFile !== null"
		 class="my-3"></v-divider>

		<v-layout v-if="audioFile !== null"
		 row
		 justify-center>
			<h1>Play recorded file</h1>
		</v-layout>

		<v-layout v-if="audioFile !== null"
		 row
		 class="audio-btns">
			<v-flex xs6
			 class="audio-btns__box">
				<v-btn @click="playAudioFile"
				 fab
				 v-if="!audioPlaying"
				 small
				 color="blue-grey darken-1">
					<v-icon>
						mdi-play
					</v-icon>
				</v-btn>
				<v-btn @click="pauseAudioFile"
				 fab
				 v-if="audioPlaying"
				 small
				 color="blue-grey darken-1">
					<v-icon>
						mdi-pause
					</v-icon>
				</v-btn>
				<v-btn @click="stopAudioFile"
				 fab
				 v-if="!audioPlaying && audioPaused"
				 small
				 color="blue-grey darken-1">
					<v-icon>
						mdi-stop
					</v-icon>
				</v-btn>
			</v-flex>
		</v-layout>

		<v-divider v-if="audioFile !== null"
		 class="my-3"></v-divider>

		<!-- <v-layout class="ma-1"
		 row
		 justify-center>
			<h2>Audio</h2>
		</v-layout> -->

		<v-layout class="ma-1"
		 row
		 justify-center>
			<h2>Text transcription</h2>
		</v-layout>

		<v-layout v-if="thisUlaTranscription.content">
			<v-flex>
				<v-card class='transcribed-text-card'>
					<v-card-text class="transcribed-text-card__body">
						<p>
							{{thisUlaTranscription.content}}</p>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

		<v-layout v-else>
			<v-flex class="text-xs-center">
				<v-card class='transcribed-text-card'>
					<v-card-text class="transcribed-text-card__body">
						<p>
							No text transcription for this file ...
						</p>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

		<v-layout class="mt-3 mb-1"
		 v-if="thisUlaTranscription.keywords"
		 row
		 justify-center>
			<h2>Keywords of this recording</h2>
		</v-layout>

		<v-layout v-if="thisUlaTranscription.keywords">
			<v-flex>
				<v-card class='transcribed-text-card'>
					<v-card-text class="transcribed-text-card__body">
						<ul class="keywords-list">
							<li v-for="(keyword,index) in keywordsNicelyDisplayed"
							 :key="index">{{keyword}}</li>
						</ul>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

		<v-layout class="ma-1"
		 row
		 justify-center>
			<h2>Summary</h2>
		</v-layout>

		<v-layout>
			<v-flex>
				<v-card class='transcribed-text-card'>
					<v-card-text class="transcribed-text-card__body">
						<template v-if="thisUlaTranscription.summary">
							<p v-for="(summarySentence,index) in summaryNicelyDisplayed"
							 :key="index">
								{{summarySentence}}
							</p>
						</template>
						<p v-else>
							There is no summary for this recording ... (probably it was too short to summarize)
						</p>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

	</div>
</template>

<script>
import { Howl, Howler } from "howler";

export default {
  props: ["audiotitle"],
  data: () => ({
    recorder: null,
    ulaFileExists: true,
    audioFile: null,
    audioPlaying: false,
    audioPaused: false,
    audioFileExistsInStorage: true
  }),
  computed: {
    thisUlaTranscription() {
      let textTranscriptions = this.$store.state.currentUser
        .userTextTranscriptions;
      if (textTranscriptions) {
        return textTranscriptions[this.audiotitle];
      }
      return { title: "No data fetched yet", date: "today", content: "" };
    },
    thisUlaSummary() {
      let allSummaries = this.$store.state.summaries;
      if (allSummaries) {
        return allSummaries[this.audiotitle];
      } else return false;
    },
    thisUlaAudioFileURL() {
      return this.$store.state.loadedAudioFile;
    },
    summaryNicelyDisplayed() {
      let unprocessedSummaries = this.thisUlaTranscription.summary;
      if (unprocessedSummaries) {
        return unprocessedSummaries.split("\n");
      } else {
        return "";
      }
    },
    keywordsNicelyDisplayed() {
      let unprocessedKeywords = this.thisUlaTranscription.keywords;
      if (unprocessedKeywords) {
        return unprocessedKeywords.split("\n");
      } else {
        return "";
      }
    }
  },
  methods: {
    playAudioFile() {
      this.audioFile.play();
      this.audioPlaying = true;
    },
    pauseAudioFile() {
      this.audioFile.pause();
      this.audioPlaying = false;
      this.audioPaused = true;
    },
    stopAudioFile() {
      this.audioFile.stop();
      this.audioPlaying = false;
      this.audioPaused = false;
    },
    checkIfAudioFinished() {
      if (
        this.recordedAudio.audioObj.ended &&
        this.recordedAudio.audioObj.currentTime > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    fetchUserRecordingItem(titleOfTheULAFile) {
      let textTranscriptions = this.$store.state.currentUser
        .userTextTranscriptions;
      //   IDEA: If the file is not null (if it exists and is already in our memory) we just return it. Otherwise, we fetch for it.
      if (textTranscriptions && textTranscriptions[titleOfTheULAFile]) {
        this.ulaFileExists = true;
      }
      return this.$store
        .dispatch("fetchSingleRecording", this.audiotitle)
        .then(resultingBoolean => {
          console.log("Im happening");
          console.log(resultingBoolean);

          if (resultingBoolean) {
            this.ulaFileExists = true;
          }
          this.ulaFileExists = false;
        })
        .catch(err => {
          console.log("problem while fetching individual ULA file !");
          console.log(err);
          if (err.code && err.code === "storage/object-not-found") {
            console.log(
              "Problem description: there is no audio file under this ULA recording in storage. Likely, the this recording only generated text transcript due to hardware limitations. Therefore, skipping displaying the audio recorder ..."
            );
            this.audioFileExistsInStorage = false;
          }
          this.ulaFileExists = false;
        });
    }
  },
  created() {
    // IDEA: I really hope you can call ".then()" on this below.. :|
    this.fetchUserRecordingItem(this.audiotitle).then(() => {
      if (this.audioFileExistsInStorage) {
        this.audioFile = new Howl({
          src: [this.thisUlaAudioFileURL],
          format: ["mp3"],
          html5: true,
          onend: () => {
            this.audioPlaying = false;
            this.audioPaused = false;
          }
        });
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.back-btn {
  transform: translateY(-55px);
}

.keywords-list {
  display: flex;
  flex-wrap: wrap;
  list-style: square;
  & li {
    margin-right: 30px;
  }
}

.audio-btns {
  justify-content: center;
  &__box {
    display: flex;
    justify-content: space-evenly;
  }
}
</style>
